var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 5.83241L7.08357 11.2491C6.39322 11.9394 6.39322 13.0587 7.08357 13.7491C7.77393 14.4394 8.89322 14.4394 9.58357 13.7491L15.0002 8.33241C16.381 6.9517 16.381 4.71312 15.0002 3.33241C13.6195 1.9517 11.381 1.9517 10.0002 3.33241L4.58357 8.74908C2.51251 10.8201 2.51251 14.178 4.58357 16.2491C6.65464 18.3201 10.0125 18.3201 12.0836 16.2491L17.5002 10.8324",
    stroke: "#868686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip2);
export default __webpack_public_path__ + "static/media/paperclip2.956980044207e23a9541e0bf23cbb2c1.svg";
export { ForwardRef as ReactComponent };